import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { environment } from 'src/environments/environment'

@Injectable({
  providedIn: 'root',
})
export class CustomsClearanceShippingReportService {

  constructor(private http: HttpClient) {}

  queryCustomsClearanceShippingReportHeader(params: any): Observable<any> {
    const url = `${environment.logisticsApiUrl}/customsClearanceShippingReport/queryCustomsClearanceShippingReportHeader`
    return this.http.post(url, params)
  }

  queryCustomsClearanceShippingReportDetail(params: any): Observable<any> {
    const url = `${environment.logisticsApiUrl}/customsClearanceShippingReport/queryCustomsClearanceShippingReportDetail`
    return this.http.post(url, params)
  }

  downloadCustomsClearanceShippingReport(downloadType: string, customsDeclarationNo: any): Observable<any> {
    const httpOptions = {
      params: {
        'downloadType': downloadType,
        'customsDeclarationNo': customsDeclarationNo,
      },
    };
    const url = `${environment.logisticsApiUrl}/customsClearanceShippingReport/downloadCustomsClearanceShippingReport`;
    return this.http.post(url, null, httpOptions);
  }
  downloadCustomsTradeExcel(customsDeclarationNo: any): Observable<any> {
    const url = `${environment.logisticsApiUrl}/customsClearanceShippingReport/downloadCustomsTradeExcel`;
    return this.http.post(url, null, {params: {customsDeclarationNo} });
  }

  queryCustomsDeclarationNoIsExists(customsDeclarationNo: any): Promise<any> {
    const url = `${environment.logisticsApiUrl}/customsClearanceShippingReport/queryCustomsDeclarationNoIsExists`
    return this.http.post(url, customsDeclarationNo).toPromise()
  }

  uploadFileAndUpdateCustomsDeclarationNo(formData: any): Observable<any> {
    const url = `${environment.logisticsApiUrl}/customsClearanceShippingReport/uploadCustomsClearanceShippingReport`
    return this.http.post(url, formData)
  }

}
